const IconChevronwRight = (): JSX.Element => {
  return (
    <>
      <path
        d="M2.6096 21.3333L9.27438e-08 18.8267L8.47658 10.6667L4.33333e-06 2.50667L2.60961 0L13.7143 10.6667L2.6096 21.3333Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconChevronwRight;
